module.exports = {
  dealDetails: {
    deals: {
      policyRenewalCompleted: null,
      anyCurrentClaimsOnThisPolicy: "Unkown",
      type: null,
      dealOwner: "22106000000065307",
      netCorporateCommissionAfterDeductible: null,
      dealStage: null,
      preferredContactTime: null,
      referralSource: null,
      dateOfClaim: "1976-07-06",
      howManyMonthsLeft: null,
      existingPolicyRenewalDueBy: null,
      fax: null,
      visitorScore: null,
      totalAdvisorCommission: null,
      areThereMultipleInsuredForThisPolicy: null,
      insuranceLeadScoringPositiveTouchPointScore: null,
      numberOfCharts: null,
      insuranceLeadScoringTouchPointScore: null,
      phone: null,
      campaignSource: null,
      lifeInsurance: null,
      productCategoryReferred: null,
      firstPageVisited: null,
      insuranceLeadScoringNegativeTouchPointScore: null,
      reRunRoundRobin: false,
      status: null,
      areThereTrusteesforThisPolicy: null,
      claimClosedOn: "1993-01-06",
      secondaryEmail: null,
      actualPolicyCommissionAfterDeductibles: null,
      insuranceLeadScoringScore: null,
      investments: null,
      claimOutcome: "Approved",
      isClientABeneficiary: null,
      insurencePartner: null,
      trustDocumentsReceivedAndUploaded: null,
      currency: "Reprehenderit ex nu",
      travelInsurance: null,
      email: null,
      locationName: null,
      daysVisited: null,
      claimAmount: 53,
      mostRecentVisit: null,
      dealName: "Omnis duis sed omnis",
      trustDissolutionDate: null,
      stage: "Delivery",
      advisorsId: null,
      roundRobinProcessed: true,
      sourceId: null,
      averageTimeSpent: null,
      eligibleRoundRobinOwnerFound: null,
      numberOfContactAttempts: null,
      isClientTheInsured: null,
      source: "catalyst",
      phoneBurnerLastCallTime: null,
      combinationHybridInsurance: null,
      exchangeRate: "Natus quibusdam qui ",
      insuranceLeadSource: "Public Relations",
      numberOfTrustees: null,
      settlementOrRejectionObservations: "Incidunt sapiente m",
      firstVisit: null,
      returnAmount: null,
      phoneA: null,
      nextFollowUpDateTime: null,
      nextFollowUpDate: null,
      contactName: null,
      insuranceLeadScoringNegativeScore: null,
      referralNameOthers: null,
      loanProtection: null,
      claimSubmitted: "Yes",
      applicationInitiatedOn: null,
      CREATEDTIME: "2024-08-02 10:00:59:961",
      referralNameClient: null,
      reasonOfClaim: "Nisi non consequat ",
      description: null,
      anyPastClaimsOnThisPolicy: "Yes",
      phoneBurnerLastCallOutcome: null,
      probabilityOfClosure: null,
      numberOfBeneficiariesUpto4: null,
      totalPolicyCommission: null,
      numberOfInsured: null,
      contactRole: null,
      totalInteractionTime: null,
      healthDentalInsurance: null,
      emailOutput: null,
      CREATORID: "22106000000155799",
      netAdvisorCommissionAfterDeductible: null,
      emailRoundRobinOwner: false,
      insuranceLeadLookup: null,
      phoneBurnerFollowUpDate: "2009-06-01",
      amount: null,
      insuranceLeadScoringPositiveScore: null,
      livingBenefits: null,
      interactionOutcome: null,
      insuranceLead: null,
      areThereMultipleBeneficiariesExclClient: null,
      layout: null,
      referrer: null,
      MODIFIEDTIME: "2024-08-02 10:00:59:961",
      servicesRequested: null,
      forecastCategory: "Pipeline",
      applicationOn: null,
      ROWID: "22106000000274790",
      roundRobinAssignmentTime: "2020-04-14T08:27",
    },
    dealInformation: {
      campaignRemove: true,
      existingInsurancePolicy: null,
      year: null,
      leadStatusStage: "New",
      understandingOfInsurance: null,
      ifreferredbyAdvisor: null,
      caDollar: null,
      groupInsurance: "Advisor",
      genderPredictionScore: null,
      adSetId: null,
      existingPolicyRenewalDueBy: null,
      emailIsValid: null,
      citizenStatus: null,
      adAccountId: null,
      adCampaignId: null,
      insuranceLeadStatus: null,
      linkedinId: null,
      socialMediaInfo: null,
      dealInformation: null,
      facebookAd: null,
      adId: null,
      preferredContactMethod: null,
      dob: null,
      doYouOwnAHouseinCanada: null,
      leadCreatedOn: null,
      adSet: null,
      CREATEDTIME: "2024-08-21 17:12:51:834",
      leadForm: null,
      faceBookPage: null,
      reassignment: null,
      adCampaign: null,
      advisorId: null,
      gender: null,
      dealId: "22106000000274790",
      rcSmsOptOut: null,
      costPerLead: null,
      twitterId: null,
      bestTimeToCall: null,
      assignedAdvisor: null,
      CREATORID: "22106000000035019",
      coverage: null,
      submitPageURL: null,
      faceBookPageId: null,
      adAccount: null,
      oldDatabaseLead: null,
      skypeId: null,
      MODIFIEDTIME: "2024-08-21 17:12:51:834",
      referredBy: null,
      netWorth: null,
      instagramId: null,
      assignedCampaigns: null,
      leadFormId: null,
      ROWID: "22106000000412196",
      additionalContactInfo: null,
    },
    dealPolicyTracking: {
      issuedDate: "2024-08-06",
      dealId: "22106000000274790",
      multipleBeneficiaries: null,
      reviewComments: null,
      applicationMedicalConfirmationNumber: null,
      commentsUpdatedOn: null,
      policyIssuedDate: "2024-08-22",
      amendmentRequestedFor: null,
      amendmentCompletedDate: "2024-08-21",
      applicationPostponed: "2024-08-09",
      clientBeneficiary: null,
      reviewedDate: "2024-08-15 02:03:02",
      CREATORID: "22106000000035019",
      policyDeclinedReason: null,
      initiatedDate: "2024-08-02",
      policyApprovedDate: "2024-08-05",
      nextFollowUpDate: "2024-08-07",
      policyRenewalDate: "2024-08-28",
      policyDeclinedDate: "2024-08-19",
      policyPickedUp: "2024-08-14",
      amendmentRequestedDate: "2024-08-22",
      applicationMedicalAppointmentDateTime: "2024-08-12 01:02:02",
      pickupPeriod: null,
      MODIFIEDTIME: "2024-08-21 17:11:59:913",
      applicationConfirmationNumber: null,
      confirmationNumber: null,
      applicationMedicalRequirement: null,
      applicationInitiatedOn: "2024-08-21",
      CREATEDTIME: "2024-08-21 17:11:59:913",
      policyExpiredDate: "2024-08-06",
      trustees: null,
      medicalRequirement: null,
      ROWID: "22106000000412193",
      approvalRating: null,
      applicationCancelled: "2024-08-28",
      startDate: "2024-08-13",
      applicationDate: null,
    },
    dealOwnership: [
      {
        CREATORID: "22106000000155799",
        multipleInsured: null,
        MODIFIEDTIME: "2024-08-02 10:01:00:480",
        clientInsured: null,
        dealId: "22106000000274790",
        numberOfInsured: "Rerum officia eos s",
        insuredEmail: "pimiki@mailinator.com",
        insuredPhone: "+1 (541) 781-88",
        CREATEDTIME: "2024-08-02 10:01:00:480",
        insuredName: "Sint laborum suscipi",
        ROWID: "22106000000277655",
      },
    ],
    dealBeneficiaries: [
      {
        CREATORID: "22106000000035019",
        MODIFIEDTIME: "2024-08-21 16:43:59:811",
        beneficiaryEmail: "peter@gmail.com",
        dealId: "22106000000274790",
        beneficiaryName: "Peter",
        beneficiaryRelationshipWithInsured: "brother",
        beneficiaryPhone: "9876543210",
        CREATEDTIME: "2024-08-21 16:43:59:811",
        ROWID: "22106000000412172",
      },
      {
        CREATORID: "22106000000035019",
        MODIFIEDTIME: "2024-08-21 16:44:23:728",
        beneficiaryEmail: "peter@fmail.com",
        dealId: "22106000000274790",
        beneficiaryName: "Advisor Peter",
        beneficiaryRelationshipWithInsured: "Brother",
        beneficiaryPhone: "98765210",
        CREATEDTIME: "2024-08-21 16:44:23:728",
        ROWID: "22106000000412175",
      },
    ],
    trustees: [
      {
        CREATORID: "22106000000035019",
        MODIFIEDTIME: "2024-08-21 16:44:57:963",
        nameOfBeneficiary: "Peter",
        policyId: null,
        phone: "9876543210",
        dealId: "22106000000274790",
        name: "Peter",
        CREATEDTIME: "2024-08-21 16:44:57:963",
        relationship: "brother",
        ROWID: "22106000000412178",
        email: "peterj@trigya.co",
      },
      {
        CREATORID: "22106000000035019",
        MODIFIEDTIME: "2024-08-21 16:45:18:324",
        nameOfBeneficiary: "Peter Anotny",
        policyId: null,
        phone: "9876543210",
        dealId: "22106000000274790",
        name: "Peter Antony",
        CREATEDTIME: "2024-08-21 16:45:18:324",
        relationship: "brother",
        ROWID: "22106000000412181",
        email: "peterjAntony@trigya.co",
      },
    ],
  },
  users: [
    {
      firstName: "trigya",
      lastName: "info",
      name: "trigya info",
      ROWID: "22106000000065307",
    },
    {
      firstName: "test",
      lastName: "trigya",
      name: "test trigya",
      ROWID: "22106000000158085",
    },
  ],
  locations: [
    {
      name: "location name update",
      ROWID: "22106000000376178",
    },
  ],
  leads: [
    {
      firstName: "Macy",
      lastName: "Gould",
      name: "Macy Gould",
      ROWID: "22106000000322869",
    },
    {
      firstName: "Ciara",
      lastName: "Luna",
      name: "Ciara Luna",
      ROWID: "22106000000341005",
    },
    {
      firstName: "advisor",
      lastName: "test",
      name: "advisor test",
      ROWID: "22106000000343903",
    },
    {
      firstName: "shobhnath ",
      lastName: "test",
      name: "shobhnath  test",
      ROWID: "22106000000346537",
    },
    {
      firstName: "first name",
      lastName: "last name ",
      name: "first name last name ",
      ROWID: "22106000000348490",
    },
    {
      firstName: "Olivia",
      lastName: "Leon",
      name: "Olivia Leon",
      ROWID: "22106000000348503",
    },
    {
      firstName: "test ",
      lastName: "email",
      name: "test  email",
      ROWID: "22106000000348721",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Client",
      name: "Peter Anotny Client",
      ROWID: "22106000000353109",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Advisor",
      name: "Peter Anotny Advisor",
      ROWID: "22106000000353173",
    },
    {
      firstName: "shobhnath test",
      lastName: "",
      name: "shobhnath test ",
      ROWID: "22106000000386371",
    },
    {
      firstName: "Chaney",
      lastName: "Dennis",
      name: "Chaney Dennis",
      ROWID: "22106000000386391",
    },
  ],
  contacts: [
    {
      firstName: "Velit sed culpa a n",
      lastName: "Quibusdam perspiciat",
      name: "Velit sed culpa a n Quibusdam perspiciat",
      ROWID: "22106000000123005",
    },
    {
      firstName: "A sit officia nulla",
      lastName: "Nesciunt sequi dolo",
      name: "A sit officia nulla Nesciunt sequi dolo",
      ROWID: "22106000000139118",
    },
    {
      firstName: "Velit vitae dolorum ",
      lastName: "Id perspiciatis es",
      name: "Velit vitae dolorum  Id perspiciatis es",
      ROWID: "22106000000255711",
    },
    {
      firstName: "Vero asperiores comm",
      lastName: "Iste consequatur eum",
      name: "Vero asperiores comm Iste consequatur eum",
      ROWID: "22106000000319749",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000346904",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Advisor",
      name: "Peter Anotny Advisor",
      ROWID: "22106000000346911",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000346929",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000346959",
    },
    {
      firstName: "contact",
      lastName: "testcontct",
      name: "contact testcontct",
      ROWID: "22106000000346966",
    },
    {
      firstName: "Macy",
      lastName: "Gould",
      name: "Macy Gould",
      ROWID: "22106000000348777",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000348810",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000348832",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000348860",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Advisor",
      name: "Peter Anotny Advisor",
      ROWID: "22106000000350626",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000350669",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000350682",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000350685",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000350689",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Client",
      name: "Peter Anotny Client",
      ROWID: "22106000000353123",
    },
    {
      firstName: "",
      lastName: "last name",
      name: " last name",
      ROWID: "22106000000353164",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Advisor",
      name: "Peter Anotny Advisor",
      ROWID: "22106000000353201",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000353206",
    },
    {
      firstName: "Peter",
      lastName: "Anotny Advisor",
      name: "Peter Anotny Advisor",
      ROWID: "22106000000353209",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000353251",
    },
    {
      firstName: "Commodi officiis atq",
      lastName: "Quia nesciunt conse",
      name: "Commodi officiis atq Quia nesciunt conse",
      ROWID: "22106000000353260",
    },
  ],
};
